import { Link } from 'react-router-dom';

const FinalCTA = () => {
  return (
    <section className="py-24 md:py-32 bg-[#060810] relative overflow-hidden">
      {/* BG effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-gradient-to-r from-cyan-600/15 to-violet-600/15 blur-[80px]" />
      </div>

      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-white/50 text-xs font-semibold mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse inline-block" />
          Şu an 14.328 kişi sohbet ediyor
        </div>
        <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
          Şimdi Başla —<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-500">
            Yeni İnsanlarla Tanış
          </span>
        </h2>
        <p className="text-white/45 text-lg mb-10 max-w-xl mx-auto">
          Kayıt gerektirmez. Ücretsiz başla. Dünyanın dört bir yanından insanlarla anında görüntülü sohbet.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/auth"
            className="group inline-flex items-center gap-3 px-10 py-5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-extrabold text-lg whitespace-nowrap cursor-pointer hover:from-cyan-400 hover:to-violet-500 transition-all duration-300 shadow-xl shadow-cyan-500/25 hover:shadow-cyan-500/40 hover:scale-105"
          >
            <i className="ri-video-on-line text-xl" />
            Ücretsiz Başla
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/auth?mode=guest"
            className="inline-flex items-center gap-2 px-8 py-5 rounded-full bg-white/5 border border-white/10 text-white/70 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-white/10 hover:text-white transition-all duration-300 backdrop-blur-sm"
          >
            <i className="ri-ghost-line" />
            Misafir Olarak Dene
          </Link>
        </div>
        <p className="text-white/25 text-xs mt-8">
          18+ platform · Gizlilik odaklı · Veri satışı yok
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
